import { cardsItems } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="relative py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            四虎影视大全编辑团队精心挑选的必看剧集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsItems.map((item, idx) => (
            <article
              key={item.id}
              className={`group bg-background-100 border border-background-200/50 hover:border-background-300/60 rounded-xl overflow-hidden transition-all duration-200 ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative ${idx === 0 ? 'aspect-[21/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/85 text-white text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 font-heading mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}